
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/politica-de-cookies",
      function () {
        return require("private-next-pages/politica-de-cookies/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/politica-de-cookies"])
      });
    }
  